import Image from "next/image"
import { HiArrowLongRight } from "react-icons/hi2"
import { IPetTransport } from "../../constants/cost-to-ship/petTransportsJson"
import formatNumber from "../../util/formatNumber"

export default function PetTransportCost({
  petTransports,
}: {
  petTransports: Array<IPetTransport>
}) {
  return (
    <section className="page-padding flex flex-col items-center space-y-4">
      <h3 className="font-montserrat font-semibold text-center text-4xl text-gray8">
        How much does it cost to transport a pet?
      </h3>
      <p className="text-center text-lg text-gray7 font-normal">
        Successful pet transports from our marketplace for as little as
        <strong className="font-semibold text-gray8">
          {" "}
          54 cents per mile.
        </strong>
      </p>
      <section className="w-full pt-10 flex flex-wrap items-center gap-10">
        {petTransports.map((transport, i) => (
          <figure
            key={`PetTransportCost/figure/${i}`}
            className="w-80 mx-auto rounded-xl overflow-hidden bg-white text-gray8 drop-shadow-card"
          >
            <Image
              className="w-full h-72 object-cover"
              src={transport.image_url[0]}
              alt={`owner with dog ${i}`}
              width={320}
              height={271}
            />
            <figcaption className="py-7 px-2 flex flex-col items-center gap-6">
              <p className="w-full m-0 text-center text-gray7 text-base">
                {transport.shipper_first_name} shipped{" "}
                <strong className="font-semibold text-gray8">
                  {" "}
                  {transport.animal_name}
                </strong>
              </p>
              <p className="w-full m-0 text-center text-lg">
                {transport.city_pickup}, {transport.state_code_pickup}{" "}
                <HiArrowLongRight className="inline-block w-6 mx-1" />{" "}
                <strong className="font-semibold">
                  {transport.city_deliver}, {transport.state_code_deliver}
                </strong>
              </p>
              <div className="w-full flex flex-col items-center space-y-1">
                <p className="text-3xl text-blue7 font-semibold font-montserrat mb-0">
                  ${formatNumber(transport.winning_bid_amount)}
                </p>
                <p className="text-sm text-gray7">
                  ${transport.winning_bid_per_mile.toFixed(2)}/mi
                </p>
              </div>
            </figcaption>
          </figure>
        ))}
      </section>
    </section>
  )
}
